"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
function gizmo() {
    var config = {
        maxErrors: 10,
        logger: console
    };
    var realOnError;
    var realLoggerError;
    function gizmoMogwai() {
        var nbErrors = 0;
        var horde = this;
        function incrementNbErrors() {
            nbErrors++;
            if (nbErrors >= config.maxErrors) {
                horde.stop();
                if (!config.logger)
                    return;
                window.setTimeout(function () {
                    config.logger.warn("mogwai ", "gizmo     ", "stopped test execution after ", config.maxErrors, "errors");
                }, 4);
            }
        }
        realOnError = window.onerror;
        window.onerror = function (message, url, linenumber) {
            incrementNbErrors();
            return realOnError ? realOnError(message, url, linenumber) : false;
        };
        realLoggerError = console.error;
        console.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            incrementNbErrors();
            realLoggerError.call.apply(realLoggerError, [console].concat(args));
        };
    }
    gizmoMogwai.cleanUp = function () {
        window.onerror = realOnError;
        console.error = realLoggerError.bind(console);
        return gizmoMogwai;
    };
    utils_1.configurable(gizmoMogwai, config);
    return gizmoMogwai;
}
exports.gizmo = gizmo;
